import { USER_ROLES, APP_TERMINAL_IDS } from '../js/constants'

/**
 * test whether a specific user is allowed to use a specific feature
 * @param {string} feature
 * @param {string} userSettings
 */
export function canUseFeature(feature, userSettings) {
  if (userSettings[feature] && userSettings[feature].enabled === true) {
    return true
  }

  return false
}

/**
 * Check if user role includes the planner role
 * @param {string[]} userRoles
 * @return {boolean}
 */
export function userIsPlanner(userRoles) {
  return userRoles && userRoles.includes(USER_ROLES.planner)
}

/**
 * Check if user role includes the order admin role
 * @param {string[]} userRoles
 * @return {boolean}
 */
export function userIsOrderAdmin(userRoles) {
  return userRoles && userRoles.includes(USER_ROLES.orderAdmin)
}

/**
 * Check if user role includes the admin role
 * @param {string[]} userRoles
 * @return {boolean}
 */
export function userIsAdmin(userRoles) {
  return userRoles && userRoles.includes(USER_ROLES.admin)
}

/**
 * Check if user role includes the readonly role
 * @param {string[]} userRoles
 * @return {boolean}
 */
export function userIsReadOnly(userRoles) {
  return userRoles && userRoles.includes(USER_ROLES.readOnly)
}

/**
 * Check if user role includes the quay coordinator role
 * @param {string[]} userRoles
 * @return {boolean}
 */
export function userIsQuayCoordinator(userRoles) {
  return userRoles && userRoles.includes(USER_ROLES.quayCoordinator)
}

/**
 * Check if user role includes the quay coordinator role
 * @param {User['roles']} userRoles
 * @return {{[role: string]: boolean}}
 */
export function userPermissionRoles(userRoles) {
  return {
    quayCoordinator: userIsQuayCoordinator(userRoles),
    readOnly: userIsReadOnly(userRoles),
    admin: userIsAdmin(userRoles),
    orderAdmin: userIsOrderAdmin(userRoles),
    planner: userIsPlanner(userRoles)
  }
}

export function hasBoardBoardSupport(terminalId) {
  return terminalId === APP_TERMINAL_IDS.cargillBotlek
}
